// @ts-nocheck
import { createI18n } from 'vue-i18n'
import { detectBrowserLanguage } from './utils/languageUtils'
import en from './locales/en.json'
import es from './locales/es.json'
import ca from './locales/ca.json'
import gl from './locales/gl.json'
import eu from './locales/eu.json'

const supportedLocales = ['en', 'es', 'ca', 'gl', 'eu']

// Use saved locale, or detect from browser/OS language
const getInitialLocale = () => {
  const savedLocale = localStorage.getItem('user-locale')
  if (savedLocale && supportedLocales.includes(savedLocale)) {
    return savedLocale
  }
  return detectBrowserLanguage(supportedLocales)
}

const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  globalInjection: true,
  messages: {
    en,
    es,
    ca,
    gl,
    eu
  }
})

export default i18n
